import { render, staticRenderFns } from "./CaDownload.vue?vue&type=template&id=125b2f93&scoped=true"
import script from "./CaDownload.vue?vue&type=script&lang=js"
export * from "./CaDownload.vue?vue&type=script&lang=js"
import style0 from "./CaDownload.vue?vue&type=style&index=0&id=125b2f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b2f93",
  null
  
)

export default component.exports